var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWilliamsLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "url(#paint0_linear_298_40)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_298_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0227 16.9879L24.2344 10.78H27.5L23.8447 21.0249L22.0227 16.9879ZM13.9811 16.9879L11.7656 10.78H8.5L12.1516 21.0249L13.9811 16.9879ZM18.2895 10.78H17.7143L12.5635 22.1778L13.6471 25.22H14.1555L17.9963 16.7295L21.8334 25.22H22.3418L23.4254 22.1778L18.2895 10.78Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_298_40",
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#306CBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013072"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_298_40"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 14.44,
    fill: "white",
    transform: "translate(8.5 10.78)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWilliamsLogo);
export default __webpack_public_path__ + "static/media/williams_logo.e9de987e90bf030a6228473f03424463.svg";
export { ForwardRef as ReactComponent };